export const selectFeatureFlagEnabled = (state, key) =>
  state.featureFlags.flags[key]?.enabled === true
